export const OPERATIONAL_AI_INSIGHTS = "OPERATIONAL_AI_INSIGHTS";

const initialState = null; 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case OPERATIONAL_AI_INSIGHTS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "operationalAiInsights"

const storeMapping = {[storeName]: reducer};

export const operationalAiInsightsSelector = (state) => state[storeName];

export default storeMapping;
